import React from 'react';
import styled from 'styled-components';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import { Link } from 'gatsby';
import CardThumbnail from '../card-details/CardThumbnail';
import { ArrowRightAlt } from '@mui/icons-material';

const CardContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding-bottom: 1.5rem;
  height: 100%;

  & .image-wrapper:hover {
    cursor: pointer;
    box-shadow: 2px 2px 10px 2px gray;
  }

  a {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    text-decoration: none;
    height: 100%;
    max-width: 100%;

    &:hover {
      h3 {
        color: #17baaa;
      }
    }

    h3 {
      display: inline-flex;
      justify-content: flex-start;
      align-items: center;
      margin-top: 0.75rem;
      transition: all 0.25s ease;
      text-align: left;
      width: 100%;
      
      svg {
        margin-left: 0.5rem;
      }
    }
  }
`;

interface CardListItemProps {
  cardId: string;
  title: string;
  uri: string;
}

const CardListItem = ({ cardId, title, uri }: CardListItemProps) => {
  return (
    <Grid item xs={6} sm={6} md={4} lg={3}>
      <CardContainer>
        <Link to={uri}>
          <CardThumbnail cardId={cardId} />
          <Typography component="h3" variant="subtitle1" align="center" color="textPrimary">{title + ' →'}</Typography>
        </Link>
      </CardContainer>
    </Grid>
  );
};

export default CardListItem;
